export const MonthsShortName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const HourlyGraphHours = ['12AM-7AM', '7AM-8AM', '8AM-9AM', '9AM-10AM', '10AM-11AM', '11AM-12PM', '12PM-1PM', '1PM-2PM', '2PM-3PM', '3PM-4PM', '4PM-5PM', '5PM-6PM', '6PM-7PM', '7PM-12PM']

export const WeekShortName = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

export const getDataSets = (data) => {
  const { colors, colorType, labels, dataKeyProps } = data;
  let arr = [];
  const graphDataArray = getGraphData(data);
  labels?.forEach((item, index) => {
    item = {
      label: labels[index],
      data: graphDataArray[index],
      [colorType]: colors[index],
      ...dataKeyProps,
    };
    arr.push(item);
  });
  return arr;
};

export const getGraphData = (data) => {
  const { dataKeys, graphData } = data;
  let arr1 = [];
  const getDataFromPath = (obj, path) => {
    return path.split('.').reduce((o, p) => (o ? o[p] : undefined), obj);
  };
  // For each dataKey, retrieve the data from the graphData object
  dataKeys?.forEach((key) => {
    const value = getDataFromPath(graphData, key);
    arr1.push(value); // No flattening here, push the value directly
  });
  return arr1; // Return an array of arrays or values as they are
};


export const getLabels = (props) => {
  const { labelType } = props

  switch (labelType) {
    case 'week':
      return WeekShortName;
    case 'hourly':
      return HourlyGraphHours;
    default:
      return MonthsShortName;
  }
}